import { AxiosResponse } from "axios";
import { api } from "../api";

// Matchea links de Drive tipo /file/d/<id>/, /d/<id>/ o ?id=<id>, ya sea
// docs.google.com o drive.google.com.
const DRIVE_URL_REGEX = /(drive|docs)\.google\.com/i;

export const isDriveUrl = (value: string): boolean =>
  DRIVE_URL_REGEX.test(value);

// Carpetas del bucket donde caen los archivos importados desde el YAML de
// quizzes, según el tipo. Son las mismas que usan los inputs de subida manual
// del editor (ImageUploadInput / AudioUploadInput).
export const GAME_QUIZ_IMAGE_FOLDER = "game-quiz/images";
export const GAME_QUIZ_AUDIO_FOLDER = "game-quiz/audios";

// Descarga un archivo (imagen o audio) desde un link de Google Drive
// (server-side, con la cuenta de servicio) y lo vuelve a subir al bucket
// propio dentro de `folder`. Devuelve la URL final en el bucket, o null si
// falló.
export const importAssetFromDriveUrl = async (
  url: string,
  folder: string,
): Promise<string | null> => {
  try {
    const response: AxiosResponse<{ url: string }> = await api.post(
      "/storage/import-from-url",
      { url, folder },
    );
    return response.status === 201 || response.status === 200
      ? response.data.url
      : null;
  } catch (error) {
    console.error(error);
    return null;
  }
};
